import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

// INTERFACES
import { IWarehouse } from '../../../shared/interfaces/location-warehouse.interface';
import { OptionInterface } from '../../interfaces';
// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})

// NOTE: This is deprecated. Don't add or reuse. Please check other existing api service like LocationWarehouseApiService.
export class WarehouseApiService {
  private readonly _defaultWarehouseLocations = new BehaviorSubject<any>(<any>{});
  private readonly _warehouses = new BehaviorSubject<OptionInterface[]>(
    <OptionInterface[]>[],
  );
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);

  warehouses$ = this._warehouses.asObservable();
  loading$ = this._loading.asObservable();
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getById(id :number) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/locations/${id}`)
      .subscribe({
        next: (response :any) => {
          this._warehouses.next(response);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getWarehouses(params :{
    [param :string] :string | string[] | any;
  }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/locations`, {
        params,
      })
      .subscribe({
        next: (response :any) => {
          if (response?.data?.length > 0) {
            const formattedData = response.data.map((row :IWarehouse) => {
              return {
                value: row.id,
                label: row.location_name,
              };
            });
            this._warehouses.next(formattedData);
          }
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getDefaultWarehouseLocation(params :{
    [param :string] :string | string[] | any;
  }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/default-warehouse-locations`, {
        params,
      })
      .subscribe({
        next: (response :any) => {
          this._defaultWarehouseLocations.next(response);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }
}
